import styled, { css } from "styled-components";
import { fontNormal, fontBold } from "@fdr/static-ui/Typography";
import buildColor from "@fdr/static-ui/ColorPalette";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InfoWrapper = styled.div`
  align-items: center;
  background-color: ${buildColor("white", "100")};
  display: flex;
  ${({ fullWidth }) =>
    fullWidth
      ? css`
          flex-direction: column;
        `
      : css`
          padding: 12px 16px;
          max-width: 100%;
        `};
  ${({ hasSeparator }) =>
    hasSeparator &&
    css`
      box-shadow: inset 0 -1px 0 ${buildColor("grey", "L2")};
    `}
`;

export const InfoLogoWrapper = styled.span`
  position: relative;
  ${({ fullWidth }) =>
    fullWidth
      ? css`
          width: 60px;
          height: 60px;
        `
      : css`
          width: 40px;
          height: 40px;
          margin-right: 15px;
          align-self: flex-start;
        `};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${buildColor("grey", "100")};
  border-radius: 50%;
`;

export const UpperIconWrapper = styled.span`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
  background-color: ${({ upperIconType }) =>
    upperIconType === "error" ? buildColor("red", "L2") : buildColor("blue")};
  border-radius: 12px;
  ${({ fullWidth }) =>
    fullWidth
      ? css`
          width: 18px;
          height: 18px;
        `
      : css`
          width: 16px;
          height: 16px;
        `};
`;

export const InfoContainer = styled.div`
  display: flex;
  max-width: 100%;
  flex-direction: column;
  flex: 1;
  word-wrap: break-word;
`;

export const InfoTitle = styled.p`
  color: ${buildColor("grey", "D4")};
  font-family: ${fontBold};
  font-size: 14px;
  line-height: 125%;
  margin-bottom: 4px;
`;

export const InfoMessage = styled.p`
  color: ${buildColor("grey", "D3")};
  font-size: 14px;
  line-height: 125%;
  font-family: ${fontNormal};
  max-width: 100%;
`;

export const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 44px;
  margin: 12px 16px;
  border-radius: 4px;
  background: none;
  border: 1px solid ${buildColor("grey", "L2")};
  color: ${buildColor("blue")};
  font-family: ${fontNormal};
  font-size: 16px;
  line-height: 100%;
  text-align: center;
  text-transform: none;
  cursor: pointer;
`;
